import React from "react"

import PageSection from "../../pageSection/pageSection.js"
import H2 from "../../h2/h2.js"
import P from "../../p/p.js"

import styles from "./supporters.module.scss"

import elysianParkImg from "../../../images/about/ElysianPark.svg"
import aforeImg from "../../../images/afore-logo.png"
import lugeImg from "../../../images/luge-logo.png"
import alpineImg from "../../../images/about/alpine-meridian-logo.png"
import magnifyImg from "../../../images/about/magnify-logo.png"

const SupportersSection = () => {
  return (
    <PageSection>
      <div className={[styles.contentContainer, styles.stackContainer].join(" ")}>
        <div className={styles.supportContainer}>
          <div className={styles.headingContainer}>
            <H2>
              Our Supporters
            </H2>
            <div className={styles.yellowBar} />
            <P className={styles.p}>
              We didn’t build Till on our own. We’re honored to have the support of a community (many of whom are parents) who share our mission of building kids into smarter spenders.
            </P>
          </div>
          <div className={styles.logosContainer}>
            <a href="https://afore.vc" target="_blank" rel="noopener noreferrer">
              <img className={styles.supporterImg} src={aforeImg} alt="Afore Capital Home" />
            </a>
            <a href="https://www.luge.vc" target="_blank" rel="noopener noreferrer">
              <img className={styles.supporterImg} src={lugeImg} alt="Luge Capital Home" />
            </a>
            <a href="http://www.elysianpark.ventures/" target="_blank" rel="noopener noreferrer" className={styles.minWidth}>
              <img className={styles.supporterImg} src={elysianParkImg} alt="Elysian Park Home" />
            </a>
            <a href="https://www.alpinemeridian.com" target="_blank" rel="noopener noreferrer">
              <img className={styles.supporterImg} src={alpineImg} alt="Alpine Meridian Ventures logo" />
            </a>
            <a href="https://www.magnify.vc/" target="_blank" rel="noopener noreferrer">
              <img className={styles.supporterImg} src={magnifyImg} alt="Magnify Ventures logo" />
            </a>
          </div>
        </div>
      </div>
    </PageSection>
  )
}

export { SupportersSection }
